import { SortableHeader } from '../../engage-automations-tab/templates-manager/templates-table/SortableHeader';
import { SegmentTableRow } from './SegmentTableRow';
import styles from './segments-manager.module.css';
import { SegmentsTableEmpty } from './SegmentsTableEmpty';
import type { SegmentListView, SegmentSortKey } from './types';

export function SegmentsTable({ sortKey, sortDirection, toggleSort, rows }: SegmentListView) {
  return (
    <>
      <div className={styles.tableScrollContainer}>
        <table className={styles.segmentsTable}>
          <thead>
            <tr>
              <SortableHeader<SegmentSortKey>
                label="Name"
                columnKey="name"
                activeSortKey={sortKey}
                sortDirection={sortDirection}
                toggleSort={toggleSort}
              />
              <SortableHeader<SegmentSortKey>
                label="Tenants"
                columnKey="tenants"
                activeSortKey={sortKey}
                sortDirection={sortDirection}
                toggleSort={toggleSort}
              />
              <SortableHeader<SegmentSortKey>
                label="Status"
                columnKey="status"
                activeSortKey={sortKey}
                sortDirection={sortDirection}
                toggleSort={toggleSort}
              />
              <SortableHeader<SegmentSortKey>
                label="Last modified"
                columnKey="lastModified"
                activeSortKey={sortKey}
                sortDirection={sortDirection}
                toggleSort={toggleSort}
              />
              <th className={styles.actionsHeader}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <SegmentTableRow key={row.segment.id} {...row} />
            ))}
          </tbody>
        </table>
      </div>

      {rows.length === 0 && <SegmentsTableEmpty />}
    </>
  );
}
